var __jsx = React.createElement;
import React, { useEffect, useState } from 'react';
import MuscleFormTextInput from '../form-text-input';
import { useTranslations } from 'next-intl';
import useAfterInitEffect from '@lib/hooks/use-after-initialization-effect';
import APP_CONFIGURATION from '@lib/app.config';
import { dateIsAfter, dateIsBefore, formatDate, isValidFormat } from '@lib/util/date-ops';
const isEmptyValue = value => value === '' || value === '  /  /    ';
const MuscleFormDateInput = _ref => {
  let {
    label,
    value,
    onChange = () => {},
    disabled = false,
    valueIsInvalid,
    setValueIsInvalid,
    invalidValueMessage,
    fullLength,
    required,
    outputFormat = APP_CONFIGURATION.config.outputDateFormat,
    minDate,
    minDateErrorMessage,
    maxDate,
    maxDateErrorMessage,
    className,
    hideGuideText = true,
    hideErrorMessage = false,
    labelClassName = '',
    placeHolderOverride,
    reserveErrorSpace = false,
    dataTestId,
    hideEmptyLabel = false
  } = _ref;
  const t = useTranslations('Shared.TextInput');
  const {
    0: textInput,
    1: setTextInput
  } = useState(value ? formatDate(value, APP_CONFIGURATION.config.dateFormat) : '');
  const {
    0: errorMessage,
    1: setErrorMessage
  } = useState(t('INVALID_DATE'));
  const {
    0: dateIsValid,
    1: setDateIsValid
  } = useState(true);
  useAfterInitEffect(() => {
    if (value) {
      if (isEmptyValue(value) && !required) {
        setTextInput('');
        setValidationStates(true);
      } else {
        setTextInput(formatDate(value, APP_CONFIGURATION.config.dateFormat));
        const valueIsValid = isValidEntry(formatDate(value, APP_CONFIGURATION.config.dateFormat));
        setValidationStates(valueIsValid);
      }
    } else {
      setTextInput('');
      setValidationStates(true);
    }
  }, [value]);
  useEffect(() => {
    if (valueIsInvalid) {
      setErrorMessage(t('INVALID_DATE'));
    }
  }, [valueIsInvalid, invalidValueMessage, t]);
  const onChangeTextInput = value => {
    setTextInput(value);
    if (isEmptyValue(value) && !required) {
      onChange('');
      setValidationStates(true);
      return;
    }
    const valueIsValid = isValidEntry(value);
    setValidationStates(valueIsValid);
    if (valueIsValid) {
      const formattedValue = formatDate(value, outputFormat, APP_CONFIGURATION.config.dateFormat);
      onChange(formattedValue);
    }
  };
  const isValidEntry = value => {
    if (!isValidFormat(value, APP_CONFIGURATION.config.dateFormat)) {
      setErrorMessage(invalidValueMessage || t('INVALID_DATE'));
      return false;
    }
    let errorMessage = t('INVALID_DATE');
    let isValidEntry = true;
    if (minDate && dateIsBefore(value, formatDate(minDate, APP_CONFIGURATION.config.dateFormat), APP_CONFIGURATION.config.dateFormat)) {
      isValidEntry = false;
      if (minDateErrorMessage) {
        errorMessage = minDateErrorMessage;
      }
    }
    if (maxDate && dateIsAfter(value, formatDate(maxDate, APP_CONFIGURATION.config.dateFormat), APP_CONFIGURATION.config.dateFormat)) {
      isValidEntry = false;
      if (maxDateErrorMessage) {
        errorMessage = maxDateErrorMessage;
      }
    }
    setErrorMessage(errorMessage);
    return isValidEntry;
  };
  const setValidationStates = isValid => {
    setValueIsInvalid === null || setValueIsInvalid === void 0 || setValueIsInvalid(!isValid);
    setDateIsValid(isValid);
  };
  return __jsx(MuscleFormTextInput, {
    disabled: disabled,
    label: label,
    value: textInput,
    mask: "00/00/0000",
    placeholder: (placeHolderOverride === null || placeHolderOverride === void 0 ? void 0 : placeHolderOverride.text) || APP_CONFIGURATION.config.dateFormat,
    placeholderClassName: placeHolderOverride === null || placeHolderOverride === void 0 ? void 0 : placeHolderOverride.textClassName,
    valueIsInvalid: !!invalidValueMessage || valueIsInvalid || !dateIsValid,
    onChangeValue: onChangeTextInput,
    invalidValueMessage: hideErrorMessage ? undefined : invalidValueMessage || errorMessage,
    fullLength: fullLength,
    required: required,
    description: hideGuideText ? undefined : APP_CONFIGURATION.config.dateFormat,
    inputClassName: className,
    labelClassName: labelClassName,
    reserveErrorSpace: reserveErrorSpace,
    dataTestId: dataTestId,
    hideEmptyLabel: hideEmptyLabel,
    inputContainerClassName: className
  });
};
export default MuscleFormDateInput;